import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams,ResponseContentType, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ComboService } from './combo.service';

@Injectable()
export class CommonService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private apiUrl = 'api/app';
    private excelUrl = 'api/common';  // URL to web api

    constructor(private http: Http,private combo:ComboService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

        getMenus(query: any): Promise<any[]> {
            let params: URLSearchParams = new URLSearchParams();
            for (let key in query) {
                params.set(key.toString(), query[key]);
            }

            let options = new RequestOptions({
                headers: this.headers,
                search: params
            });

            const url = `${this.apiUrl}/getMenu`;
            return this.http.get(url, options)
                .toPromise()
                .then(this.extractData)
                .catch(this.handleError);
        }
        save(query: any): Promise<any[]> {
            let params: URLSearchParams = new URLSearchParams();
            for (let key in query) {
                params.set(key.toString(), query[key]);
            }
    
            let options = new RequestOptions({
                headers: this.headers,
                search: params
            });
    
            const url = `${this.apiUrl}/save`;
            return this.http.get(url, options)
                .toPromise()
                .then(this.extractData)
                .catch(this.handleError);
        }
    
   

    loadPartyList(query: any): Observable<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/partyList`;
        return this.http.get(url, options)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }

    loadCompanyList(query: any): Observable<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/companyList`;
        return this.http.get(url, options)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    } 

    printExcel(printData: any): Promise<any> {
        const url = `${this.excelUrl}/ExportExcel`;
        return this.http
            .post(url, $.param(printData), { headers: this.headers,  responseType: ResponseContentType.ArrayBuffer })
            .toPromise()
            .then(res => res)
    }



    itemMaster(){
        let data:any ={
            slv:['F/S','H/S'],
            size:['36','38','40','42','44','46'],
            width:[36,44,58],
            style:['FORMAL','STYLISH FORMAL','CASUAL','CLUBWEAR','RR FORMAL','RR CASUAL','CLUB'],
            fit:['COMFORT FIT','RELAX FIT','SLIM FIT'],
            brand:['EXPOSE','ARAZA','GREEN OLIVE','JOB'],
            wash_srink:['0%','3%','5%'],
            but_placket:['3/4 Inch','3/4.1 Inch'],
            cuff_no:['Square','Round'],
            thread_qly:['50 TKT','120 TKT'],
            bobbin_qly:['120 TKT'],
            thread_cons:{
                FORMAL: ['90 CM'],
                'STYLISH FORMAL': ['90 CM'],
                CASUAL:['45 CM'],
                CLUBWEAR:['90 CM'],
                CLUB: ['90 CM'],
                'RR FORMAL': ['90 CM'],
                'RR CASUAL':['45 CM']
            },
            bobbin_cons:{
                CASUAL:['45 CM'],
            },
            thread_type:{
                FORMAL: ['180 MTRS'],
                'STYLISH FORMAL': ['180 MTRS'],
                CASUAL:['2000 MTRS'],
                CLUBWEAR:['180 MTRS'],
                CLUB: ['180 MTRS'],
                'RR FORMAL': ['180 MTRS'],
                'RR CASUAL':['2000 MTRS']
            },
            bobbin_type:{
                FORMAL: ['180 MTRS'],
                'STYLISH FORMAL': ['180 MTRS'],
                CASUAL:['180 MTRS'],
                CLUBWEAR:['180 MTRS'],
                CLUB: ['180 MTRS'],
                'RR FORMAL': ['180 MTRS'],
                'RR CASUAL':['180 MTRS']
            },
            placket:['20 MM','25 MM','22 MM','29 MM'],
            main_label:{
                FORMAL: ['FL-01', 'FL-03', 'FL-05', 'FL-07','FL-09', 'FL-10', 'FL-11', 'FL-12','FL-13','FL-15'],
                'STYLISH FORMAL': ['FL-01', 'FL-03', 'FL-05', 'FL-07','FL-09', 'FL-10', 'FL-11', 'FL-12','FL-13','FL-15'],
                CASUAL:['CL-30', 'CL-33', 'CL-34'],
                CLUBWEAR:['CB-50', 'CB-51', 'CB-52', 'CB-53','CB-54', 'CB-55', 'CB-56', 'CB-57'],
                'RR FORMAL': ['FL-01', 'FL-03', 'FL-05', 'FL-07','FL-09', 'FL-10', 'FL-11', 'FL-12','FL-13','FL-15'],
                CLUB: ['FL-01', 'FL-03', 'FL-05', 'FL-07','FL-09', 'FL-10', 'FL-11', 'FL-12','FL-13','FL-15'],
                'RR CASUAL':['CL-30', 'CL-33', 'CL-34']
            },
            extra_label:{
                FORMAL: ['FL-02', 'FL-04', 'FL-06', 'FL-08','FL-14', 'FL-16', 'FL-17'],
                'STYLISH FORMAL': ['FL-02', 'FL-04', 'FL-06', 'FL-08','FL-14', 'FL-16', 'FL-17'],
                CASUAL:['CL-31', 'CL-32', 'CL-35', 'CL-36'],
                'RR FORMAL': ['FL-02', 'FL-04', 'FL-06', 'FL-08','FL-14', 'FL-16', 'FL-17'],
                CLUB: ['FL-02', 'FL-04', 'FL-06', 'FL-08','FL-14', 'FL-16', 'FL-17'],
                'RR CASUAL':['CL-31', 'CL-32', 'CL-35', 'CL-36'],
            },
            wash_care:{
                FORMAL: ['FL-18'],
                'STYLISH FORMAL': ['FL-18'],
                CASUAL:['CL-37'],
                CLUBWEAR:['CB-58'],
                'RR FORMAL': ['FL-18'],
                CLUB: ['FL-18'],
                'RR CASUAL':['CL-37'],
            },
            bone:['1 1/2 Inch','2 Inch'],
            tape_no:['T-01', 'T-02', 'T-03', 'T-04', 'T-05','T-06', 'T-07', 'T-08', 'T-09', 'T-10','T-11', 'T-12', 'T-13', 'T-14'],
            tape_cons:'0.50 MTRS',
            kaja_type:['Regular','Double Kaja'],
            kthread_cons:'790 CM',
            bthread_cons:'385 CM',
            fabric_style:{
                checks:['SMALL CHECKS - 1 INCH','MEDIUM CHECKS - 2 INCH','BIG CHECKS'],
                stripes:['SMALL STRIPE - 1 INCH','MEDIUM STRIPE - 2 INCH'],
                printed:['PRINTED'],
                border:['ONE SIDE BORDER SMALL','TWO SIDE BORDER SMALL','ONE SIDE 8 TO 9 INCH BORDER'],
                pannel:['PANNEL 180 CM','PANNEL 90 CM'],
                plain:['PLAIN'],
            },
            collar_no:{
               FORMAL:['CLASSIC'],
               'STYLISH FORMAL':['CLASSIC'],
               CASUAL:['CASUAL'],
               CLUBWEAR:['SEMI','STRAIGHT','CHINESE','LONGPOINT',"I-NECK"],
               'RR FORMAL':['CLASSIC'],
               'CLUB':['CLASSIC'],
               'RR CASUAL':['CASUAL'],
            },
            data:{
                collar_no_Formal_CLASSIC:['COLLAR UP','COLLAR DOWN','BAND'],
                collar_no_Casual_CASUAL:['COLLAR DOWN','BAND'],
                collar_no_Clubwear_SEMI:['COLLAR UP','COLLAR DOWN','BAND'],
                collar_no_Clubwear_STRAIGHT:['COLLAR UP','COLLAR DOWN','BAND'],
                collar_no_Clubwear_CHINESE:['COLLAR UP','COLLAR DOWN','BAND'],
                collar_no_Clubwear_LONGPOINT:['COLLAR DOWN','BAND'],

            }
        };

        return data;

    }


    getSeasonList(id){
        var param = {
            "date":id
        };
        return this.combo.getSeason(param);
    }

    getCurrentFinyear(){
        var date = new Date(),
        month = date.getMonth() + 1,
        year = date.getFullYear(),
        startFinYear = 2019,
        endFinYear = 2020;
        if(month < 4){
            startFinYear = year-1;
            endFinYear = year;
        }else{
            startFinYear = year;
            endFinYear = year +1;
        }

        return startFinYear+'-'+endFinYear;
    }

    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/common.service.ts